import React from 'react';
import './css/App.css';
import MotifQuery from './MotifQuery';

function App() {
  return <MotifQuery />;
}

export default App;